import React from 'react'
import AddUser from '../../components/admin/users/AddUser'

function AddUserPage() {
  return (
   <AddUser/>
  )
}

export default AddUserPage